
define('tmpl!core/templates/webidl/maplike.html', ['deps/handlebars'], function (hb) { return hb.compile('<span class=\'idlMaplike\'>{{extAttr obj indent true\n}}{{idn indent}}{{readonly}}maplike&lt;<span class=\'idlMaplikeKeyType\'>{{datatype obj.key}}</span>, <span class=\'idlMaplikeValueType\'>{{datatype obj.value}}</span>&gt;;</span>\n');});

